import styles from "./BigPromo.module.scss";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import useBigPromo from "./useBigPromo.ts";

export default function BigPromo({ className }: { className?: string }) {
  const item = useBigPromo();

  if (!item) {
    return null;
  }

  return (
    <div
      className={clsx(styles.box, className)}
      style={{ backgroundImage: `url(${item.imgSrc})` }}
    >
      <div className={styles.text}>
        <h3>{item.title}</h3>
        <div className={styles.subtext}>{item.body}</div>
        <BaseLinkOrButton
          className={clsx(
            "vst-button-pill",
            "vst-button-variant-white-outline"
          )}
          href={item.href}
          to={item.to}
        >
          {item.linkText}
        </BaseLinkOrButton>
      </div>
    </div>
  );
}
